
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25.112","height":"20.686"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Twitter-logo","d":"M21.945 5.527c.014.208.014.416.014.626A13.69 13.69 0 018.176 19.936h0A13.714 13.714 0 01.75 17.761a9.853 9.853 0 001.153.07 9.727 9.727 0 006.016-2.078 4.85 4.85 0 01-4.526-3.364 4.829 4.829 0 002.187-.083 4.845 4.845 0 01-3.885-4.753v-.057a4.814 4.814 0 002.2.606 4.85 4.85 0 01-1.5-6.468 13.749 13.749 0 009.984 5.061 4.849 4.849 0 018.255-4.418 9.721 9.721 0 003.076-1.176 4.862 4.862 0 01-2.13 2.679 9.634 9.634 0 002.782-.763 9.841 9.841 0 01-2.417 2.509z","fill":"none","stroke":"#5a677b","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    